import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Grid",
  "use": "Grid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"Grid\"><path fill=\"currentColor\" d=\"M.284.158H6.6V6.79H.284zm0 8.526H6.6v6.632H.284zm0 8.527H6.6v6.632H.284zM8.179.158h6.632V6.79H8.179zm0 8.526h6.632v6.632H8.179zm0 8.527h6.632v6.632H8.179zM16.705.158h6.632V6.79h-6.632zm0 8.526h6.632v6.632h-6.632zm0 8.527h6.632v6.632h-6.632z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol